// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Avv3","buttons":"PendingPaymentAlert_buttons__2E9_D"};